<template>
  <div>
    <md-tabs
      @md-changed="catalogChanged"
      class="header-tabs">
      <md-tab
        id="tab-active"
        md-label="Active" />
      <md-tab
        id="tab-library"
        md-label="Bibliothèque" />
    </md-tabs>
    <div class="page-container">
      <div class="box">
        <h1>Actions par catégories</h1>
        <md-list>
          <md-list-item
            v-for="categoryData in actionSettingsListByCategories"
            :key="'category_'+categoryData.label"
            md-expand
            :md-expanded="expandedListCategoryId === categoryData.label"
            @update:mdExpanded="setExpandedListCategoryId(categoryData.label, $event)">
            <h2 class="md-list-item-text">{{ categoryData.label }}</h2>

            <md-list slot="md-expand">
              <md-list-item
                v-for="actionData in categoryData.actions"
                :key="'action_'+actionData.id"
                md-expand
                :md-expanded="expandedListActionId === actionData.id"
                @update:mdExpanded="setExpandedListActionId(actionData.id, $event)">
                <h3 class="table-heading">
                  {{ actionData.action_label }}
                  <md-badge
                    class="md-square"
                    :md-content="actionData.action_level" />
                </h3>

                <md-list
                  slot="md-expand"
                  class="under__list">
                  <md-table
                    v-model="actionData.action_settings"
                    class="action-settings-table">
                    <md-table-row
                      slot="md-table-row"
                      slot-scope="{ item }">
                      <md-table-cell
                        :md-label="actionData.label"
                        :class="{ 'md-table-cell-first-column': true }">
                        <md-button
                          class="md-table-cell-first-column-label"
                          :md-ripple="false"
                          @click="showDialog(item.id)">
                          <md-icon v-if="!item.is_user_defined">lock</md-icon>
                          <md-icon v-if="item.is_user_defined">edit</md-icon>
                          {{ item.label }}
                        </md-button>
                        <md-menu md-close-on-click>
                          <md-icon md-menu-trigger>more_vert</md-icon>
                          <md-menu-content>
                            <md-menu-item
                              @click="showDialog(item.id)"
                              v-if="item.is_user_defined"><md-icon>edit</md-icon> Modifier</md-menu-item>
                            <md-menu-item
                              @click="showDialog(item.id)"
                              v-if="!item.is_user_defined"><md-icon>visibility</md-icon> Voir</md-menu-item>
                            <md-menu-item
                              @click="promptDuplicate(item)"><md-icon>filter_none</md-icon> Dupliquer</md-menu-item>
                            <md-menu-item
                              @click="confirmActionDelete(item)"
                              v-if="item.is_user_defined"><md-icon>delete</md-icon> Supprimer</md-menu-item>
                          </md-menu-content>
                        </md-menu>
                      </md-table-cell>
                      <md-table-cell
                        md-label="Lieux concernés">
                        <md-menu
                          md-close-on-click
                          v-if="getFunctionOrPlaces(item).length > 1">
                          <md-button
                            md-menu-trigger
                            class="md-icon-button">
                            {{ getFunctionOrPlaces(item).length }}
                          </md-button>
                          <md-menu-content>
                            <md-menu-item
                              v-for="item in getFunctionOrPlaces(item)"
                              :key="item">
                              {{ item }}
                            </md-menu-item>
                          </md-menu-content>
                        </md-menu>
                        <span v-if="getFunctionOrPlaces(item).length === 1">{{ getFunctionOrPlaces(item)[0] }}</span>
                      </md-table-cell>
                      <md-table-cell
                        md-label="Coût énergie moyen">
                        {{ getFormatedValue(item.avg_action_investment.energy_investment) }}
                        <span v-html="splitUnit(item.avg_action_investment.unit)[0]" />
                        <div v-html="splitUnit(item.avg_action_investment.unit)[1]" />
                      </md-table-cell>
                      <md-table-cell
                        md-label="Coût global moyen">
                        {{ getFormatedValue(item.avg_action_investment.total_investment) }}
                        <span v-html="splitUnit(item.avg_action_investment.unit)[0]" />
                        <div v-html="splitUnit(item.avg_action_investment.unit)[1]" />
                      </md-table-cell>
                      <template
                        v-for="actionUse in item.action_use">
                        <md-table-cell
                          :md-label="actionUse.label"
                          :key="'actionuse_'+actionUse.id">
                          <target-values-inline-list
                            v-if="actionUse.target_values"
                            :display-value="getFormatedValue(actionUse.value)"
                            :target-values="actionUse.target_values" />
                          <template v-if="!actionUse.target_values">
                            {{ getFormatedValue(actionUse.value) }}
                            <template v-if="actionUse.value !== null">
                              <span v-html="splitUnit(actionUse.unit)[0]" />
                              <div v-html="splitUnit(actionUse.unit)[1]" />
                            </template>
                          </template>
                        </md-table-cell>
                      </template>
                      <md-table-cell
                        md-label="Durée de vie de l'action">
                        {{ item.action.lifetime }}
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-list>
              </md-list-item>
            </md-list>
          </md-list-item>
        </md-list>
      </div>
      <action-base-detail-dialog
        :md-active.sync="isDialogOpen"
        :action-id="editedActionId"
        @reload="loadActionSettingsList" />
      <md-dialog-confirm
        :md-active.sync="deleteConfirmDialog.active"
        md-title="Supprimer le paramètre d'action ?"
        :md-content="deleteConfirmDialog.content"
        md-confirm-text="Supprimer"
        md-cancel-text="Annuler"
        @md-cancel="deleteConfirmDialog.active = false"
        @md-confirm="onDeleteConfirm" />
      <md-dialog-prompt
        :md-active.sync="duplicatePromptDialog.active"
        @md-confirm="onDuplicateConfirm"
        md-title="Donnez un nom au nouveau paramètre d'action"
        md-input-maxlength="150"
        :md-input-placeholder="duplicatePromptDialog.currentLabel"
        md-confirm-text="Dupliquer"
        md-cancel-text="Annuler" />
    </div>
  </div>
</template>

<script>
import session from '../api/session'
import groupBy from 'lodash/groupBy'
import ActionBaseDetailDialog from '../views/ActionBaseDetailDialog'
import ValuesDisplayMixin from '../mixins/ValuesDisplayMixin'
import TargetValuesInlineList from '../components/TargetValuesInlineList'

export default {
  name: 'ActionBase',
  mixins: [ValuesDisplayMixin],
  components: {
    ActionBaseDetailDialog,
    TargetValuesInlineList
  },
  data () {
    return {
      catalogType: 'active',
      actionSettingsData: [],
      currentDialogComponent: 'ActionBaseDetailDialog',
      expandedListCategoryId: '',
      expandedListActionId: '',
      isDialogOpen: false,
      editedActionId: null,
      deleteConfirmDialog: {
        active: false,
        actionSettingsId: null,
        content: 'Voulez-vous supprimer définitivement le paramètre d\'action : {label} ?'
      },
      duplicatePromptDialog: {
        active: false,
        actionSettingsId: null,
        newLabel: null,
        currentLabel: null
      }
    }
  },
  mounted: function () {
    this.$store.dispatch('routing/update_title', 'Base d\'actions')
    this.$store.dispatch('routing/update_return_kwargs', null)
    this.loadActionSettingsList()
  },
  computed: {
    actionSettingsListByCategories () {
      let filteredactionSettingsData = this.actionSettingsData.filter(actionSetting =>
        actionSetting.is_in_library === (this.catalogType === 'library')
      )
      return this.processListData(filteredactionSettingsData)
    }
  },
  methods: {
    catalogChanged: function (catalogType) {
      switch (catalogType) {
        case 'tab-active':
          this.catalogType = 'active'
          break
        case 'tab-library':
          this.catalogType = 'library'
          break
      }
    },
    loadActionSettingsList: function () {
      let app = this

      app.$store.dispatch('loading/begin_loading')

      session.get(`/api/actions/settings/`)
        .then(function (results) {
          app.actionSettingsData = results.data
          app.$store.dispatch('loading/end_loading')
        })
        .catch(function (error) {
          var response = error.response
          app.$store.dispatch('loading/end_loading')
          if (response.status === 500) {
            app.$store.commit('errors/SHOW', {})
          }
        })
    },
    processListData: function (data) {
      /*
        Group data by Categories > Actions > ActionSettings
        Need optimization
      */

      let dataGroupedByCategory = groupBy(data, 'action.category_label')

      Object.entries(dataGroupedByCategory).forEach(([category, actionSettingsList]) => {
        let dataGroupedByAction = {}

        Object.entries(actionSettingsList).forEach(([key, actionSettings]) => {
          if (dataGroupedByAction.hasOwnProperty(actionSettings.action.id)) {
            dataGroupedByAction[actionSettings.action.id].action_settings.push(actionSettings)
          } else {
            dataGroupedByAction[actionSettings.action.id] = {
              id: actionSettings.id,
              label: 'Paramètres',
              action_label: actionSettings.action.label,
              action_level: actionSettings.action.level,
              action_settings: [actionSettings],
              is_expanded: false
            }
          }
        })

        dataGroupedByCategory[category] = {
          label: category,
          actions: dataGroupedByAction,
          is_expanded: false
        }
      })

      return dataGroupedByCategory
    },
    setExpandedListCategoryId: function (id, val) {
      if (val === true) {
        this.expandedListCategoryId = id
      } else if (this.expandedListCategoryId === id) {
        this.expandedListCategoryId = ''
      }
    },
    setExpandedListActionId: function (id, val) {
      if (val === true) {
        this.expandedListActionId = id
      } else if (this.expandedListActionId === id) {
        this.expandedListActionId = ''
      }
    },
    getFunctionOrPlaces: function (item) {
      if (typeof item.function_or_places === 'string') {
        return [item.function_or_places]
      } else {
        return item.function_or_places
      }
    },
    showDialog: function (actionId) {
      this.editedActionId = actionId
      this.isDialogOpen = true
    },
    closeDialog: function () {
      this.isDialogOpen = false
    },
    confirmActionDelete: function (actionSettings) {
      this.deleteConfirmDialog.content = this.deleteConfirmDialog.content.replace('{label}', actionSettings.label)
      this.deleteConfirmDialog.actionSettingsId = actionSettings.id
      this.deleteConfirmDialog.active = true
    },
    onDeleteConfirm: function () {
      let app = this

      app.deleteConfirmDialog.active = false
      app.$store.dispatch('loading/begin_loading')
      let actionSettingsId = app.deleteConfirmDialog.actionSettingsId

      session.delete(`/api/actions/settings/${actionSettingsId}/`)
        .then(function () {
          app.$store.commit('messages/SHOW', {
            label: 'Supprimé',
            description: 'Le paramètre d\'action a été supprimé.'
          })
          app.deleteConfirmDialog.actionSettingsId = null
          app.loadActionSettingsList()
        })
        .catch(function (error) {
          var response = error.response
          app.$store.dispatch('loading/end_loading')
          if (response.status === 500) {
            app.$store.commit('errors/SHOW', {})
          }
        })
    },
    promptDuplicate: function (actionSettings) {
      this.duplicatePromptDialog.actionSettingsId = actionSettings.id
      this.duplicatePromptDialog.currentLabel = actionSettings.label
      this.duplicatePromptDialog.active = true
    },
    onDuplicateConfirm: function (newLabel) {
      let app = this

      app.duplicatePromptDialog.active = false
      app.$store.dispatch('loading/begin_loading')
      let actionSettingsId = app.duplicatePromptDialog.actionSettingsId

      session.post(`/api/actions/settings/${actionSettingsId}/duplicate/`, {
        'label': newLabel
      })
        .then(function () {
          app.$store.commit('messages/SHOW', {
            label: 'Dupliqué',
            description: 'Le paramètre d\'action a été dupliqué.'
          })
          app.duplicatePromptDialog.actionSettingsId = null
          app.loadActionSettingsList()
        })
        .catch(function (error) {
          var response = error.response
          app.$store.dispatch('loading/end_loading')
          if (response.status === 500) {
            app.$store.commit('errors/SHOW', {})
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../stylesheets/variables";

.header-tabs >>> {
  .md-tabs-navigation {
    .md-button{
      font-size: 14px;
      margin-left: 15px;
    }
  }
}

.md-table.action-settings-table >>> {
  .md-table-head:first-child {
    .md-table-head-container {
      padding-left: 1em;
      text-align: left;
    }
  }

  .md-table-head-label,
  .md-table-head-container,
  .md-table-cell-container {
    padding-left: .5em;
    padding-right: .5em;
    text-align: center;
  }

  .md-button {
    min-width: auto;
  }
}

.md-table-cell-first-column >>> .md-table-cell-container {
  display: flex;
  justify-content: space-between;
  text-align: left;
  align-items: center;
}

.md-table-cell-first-column-label {
  flex: 2 0 auto;
  >>> .md-ripple {
    justify-content: left;
  }
}

.md-list-item-container {
  &:hover {
    background-color: transparent !important;
  }
}
.md-list {
  .md-list {
    //border-left: 5px solid project-theme("primary");
    padding: 0;
  }
}
.md-list-item {
  border-left: 3px solid project-theme("primary");
}
.md-list-item .md-list-item {
  border-left: 0;
}
.md-list-item-container >>> .md-list-item-content {
  background-color: white;
}

.md-list-item-expand >>> .md-list-item-content h3 {
  background: rgb(247, 247, 247);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding-top: 16px;
}

.md-list-item-expand >>> .md-list-item-content i {
  position: absolute;
  right: 10px;
}

// WORKAROUND: this will be fixed in https://github.com/vuematerial/vue-material/commit/739cefafe7894aad708eab74d9323da11555fd13#diff-27d478d3e9bcc15f457548823c5f95d1
.md-list-item-expand.md-active >>> .md-list-item-content i {
  transform: none;
}

.md-list-item-expand.md-active >>>{
  > .md-list-item-content > .md-list-expand-icon {
  transform: rotateX(180deg);
}
}
// END WORKAROUND

.table-heading >>> .md-badge {
  display: inline-block;
  font-size: 0.8em;
  height: auto;
}

.dialog-tables-margin {
  margin-bottom: 2em;
}

.box {
  margin: 2rem;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 1px 1px 30px 1px rgba(black, 0.1);

  ul {
    padding: 0;
  }
  h1,
  h2,
  h3 {
    margin: 0;
    font-weight: normal;
  }

  h1 {
    padding: 1rem;
    font-size: 1.2rem;
    font-weight: bold;
    border-bottom: 1px solid project-theme("background");
  }

  h2 {
    font-size: 1.1rem;
  }

  h3 {
    font-size: 0.9rem;
    padding-left: 2rem;
  }

  li {
    border-bottom: 1px solid project-theme("background");
    &:last-child {
      border-bottom: 0;
    }
  }
}

.under__list {
  margin-left: 2rem;
  border-left: 1px dashed #eee;
  padding-left: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/ActionBase.vue